module.exports = __webpack_public_path__ + "images/like-normal-8ef53caa.svg";